export enum GroupScType {
  'IND' = 'INDIV',
  'GROUP' = 'GRP',
}
